import { render, staticRenderFns } from "./SelectLocation.vue?vue&type=template&id=524d9a27&scoped=true&"
import script from "./SelectLocation.vue?vue&type=script&lang=js&"
export * from "./SelectLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d9a27",
  null
  
)

export default component.exports